<template>
	<div id="global-search" ref="globalSearch" class="d-flex align-center justify-center">
		<div id="global-search--field">
			<v-text-field
				v-model.trim="search"
				hide-details
				solo
				placeholder="Search for an ID"
				rounded
				clearable
				append-icon="mdi-magnify"
				@input="aboutToSearch = true"
				@click="clickedResult = false"
				@keydown.esc="reset">
			</v-text-field>
		</div>
		<div v-if="(search || noResults) && !clickedResult && !aboutToSearch" id="global-search--results">
			<v-card :loading="isLoading">
				<v-list
					subheader
					two-line>
					<div id="global-search--v-list-container">
						<template v-if="projects.length">
							<v-subheader class="d-flex" style="background-color: #5b9ccf">
								<div class="mr-auto font-weight-bold white--text text-h6">Projects</div>
								<div class="mr-2"><v-icon color="white">mdi-folder-check</v-icon></div>
							</v-subheader>

							<v-divider />

							<v-list-item v-for="project in projects"
								:key="`gs-project-` + project.id"
								@click="vLink('projects.show', project); clickedResult = true">
								<v-list-item-content>
									<v-list-item-title>
										#{{ project.id }} <span v-if="project.name">- {{ project.name }}</span>
										<span v-if="project.status" class="font-weight-light ml-2">
											(<span class="text-uppercase font-weight-bold" :class="project.status.color.split(' ')[0] + '--text'">{{ project.status.name }}</span>)
										</span>
									</v-list-item-title>
									<v-list-item-subtitle v-if="project.client" v-text="project.client.name"></v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</template>

						<template v-if="invoices.length">
							<v-subheader class="d-flex" style="background-color: #5b9ccf">
								<div class="mr-auto font-weight-bold white--text text-h6">Invoices</div>
								<div class="mr-2"><v-icon color="white">mdi-bank-check</v-icon></div>
							</v-subheader>

							<v-divider />

							<v-list-item v-for="invoice in invoices"
								:key="`gs-invoice-` + invoice.id"
								@click="vLink('invoices.show', invoice); clickedResult = true">
								<v-list-item-content>
									<v-list-item-title>
										#{{ invoice.id }}
										<span v-if="invoice.project && invoice.project.name">- {{ invoice.project.name }}</span>
										<span class="font-weight-light ml-2">(<span class="text-uppercase font-weight-bold" :class="invoice.status === 'paid' ? 'success--text' : 'warning--text'">{{ invoice.status }})</span></span>
									</v-list-item-title>
									<v-list-item-subtitle v-if="invoice.project && invoice.project.client"
										v-text="invoice.project.client.name"></v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</template>

						<v-list-item v-if="noResults && !loading && !aboutToSearch" class="p-0 mt-1">
							<div class="text-center text-muted w-100"><em>Nothing found, try another search?</em></div>
						</v-list-item>
					</div>
				</v-list>
			</v-card>
		</div>
	</div>
</template>

<script>

import _ from 'lodash'
import api from '@/api'

export default {
	data: () => ({
		aboutToSearch: false,
		entries: [],
		loading: 0,
		search: null,
		projects: [],
		invoices: [],
		clickedResult: false
	}),

	computed: {
		isLoading () {
			return this.loading >= 1
		},

		noResults () {
			return this.search
				&& this.projects.length === 0
				&& this.invoices.length === 0
		}
	},

	watch: {
		search: {
			handler: _.debounce(function (newVal, oldVal) {
				if(newVal === '' || !newVal) {
					this.reset()
					return
				}

				this.clickedResult = false

				if (this.isLoading) return

				if (newVal && newVal !== oldVal || !newVal && oldVal) {
					this.getProjects()
					this.getInvoices()
				}
			}, 500)
		}
	},

	mounted () {
		document.addEventListener('click', this.onClickOutside)
	},

	beforeDestroy () {
		document.removeEventListener('click', this.onClickOutside)
	},

	methods: {
		reset () {
			this.search = ''
			this.loading = 0
			this.projects = []
			this.invoices = []
			this.aboutToSearch = false
		},

		getProjects () {
			this.loading++

			const method = 'GET'
			const data = {}

			const url = this.route('projects.api.global-search', { search: this.search })

			return api({
				method,
				url,
				data
			}).then(response => {
				this.projects = response.data
				this.aboutToSearch = false
				this.loading--
			})
		},

		getInvoices () {
			this.loading++

			const method = 'GET'
			const data = {}

			const url = this.route('invoices.api.global-search', { search: this.search })

			return api({
				method,
				url,
				data
			}).then(response => {
				this.invoices = response.data
				this.aboutToSearch = false
				this.loading--
			})
		},

		onClickOutside (event) {
			if (! this.$refs.globalSearch.contains(event.target)) {
				this.clickedResult = true
			}
		}
	}
}
</script>
